module.exports = __webpack_public_path__ + "static/media/user-random.3dd39275.gif";